module.exports = __webpack_public_path__ + "img/congestion-status-laundry_odd.46fd9a75.svg";